import React from 'react'
import PropTypes from 'prop-types';
import { List } from '@leverege/ui-elements'

import ListModal from '../../views/ListModal';

export default class ScenarioSelector extends React.Component {

  static contextTypes = {
    api : PropTypes.object
  }

  static propTypes = {
    onItemSelected : PropTypes.func,
    projectId : PropTypes.string.isRequired,
    blueprintId : PropTypes.string.isRequired,
    flagName : PropTypes.string,
    showFlag : PropTypes.bool,
    initialFlag : PropTypes.bool
  }

  constructor( props ) {
    super( props )
    this.state = { scenarios : [],
                   loading : true,
                   error : null,
                   flag : props.initialFlag == null ? true : props.initialFlag }

    this.selector = new List.SingleSelector( this, 'noKeySelection', { onSelect : this.onItemSelected } )
  }

  onItemSelected = ( { data } ) => {
    const { onHide, onItemSelected } = this.props
    const { flag } = this.state
    if ( onItemSelected ) {
      onItemSelected( data, flag )
    }

    if ( onHide() ) {
      onHide()
    }
  }

  componentWillMount( ) {
    this.mounted = true
    const { api } = this.context
    const { projectId, blueprintId } = this.props

    if ( api && projectId ) {
      this.request = api.getScenarios( projectId, blueprintId ).then( ( result ) => {
        if ( this.mounted ) { 
          this.setState( { scenarios : result.items, loading : false } )
        }
      } ).catch( ( ex ) => {
        if ( this.mounted ) { 
          this.setState( { error : ex, loading : true } )
        }
      } )
    }
  }

  componentWillUnmount() {
    this.mounted = false
  }

  render() {
    const { scenarios, flag } = this.state
    const { projectId, blueprintId, message, onItemSelected, showFlag, initialFlag, flagName, show, onHide, ...rest } = this.props

    const mtypes = scenarios.map( ( item, index ) => {
      return (
        <List.Item
          key={item.id}
          item={item}>
          {item.name}
        </List.Item>
      ) 
    } );

    return (
      <ListModal
        mtypes={mtypes}
        message={message}
        onClose={onHide}
        show={show}
        showFlag={showFlag}
        flagName={flagName}
        flag={flag}
        title="Scenarios"
        onClick={this.onItemSelected}
        onFlag={( { value } ) => { this.setState( { flag : value } ) }} />
    )
  }
}
